import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Observable } from 'rxjs';
import { TradeRequest } from '../_interfaces/trade-request';

@Injectable({
  providedIn: 'root',
})
export class TradeRequestService {

  constructor(private http: HttpClient) {}

  getAllTradeRequests(filter : any): Observable<TradeRequest[]> {
    const data =  this.http.post<TradeRequest[]>('/users/trade/requests',filter);
    return data;
  }

  getPresignedSignedUrl(key: string): Observable<string> {
    const data =  this.http.post<string>('/users/trade/url',{key: key});
    return data;
  }


  approveTradeRequest(approveReq: TradeRequest): Observable<any> {
    const data =  this.http.post<TradeRequest[]>('/users/trade/approve', approveReq);
    return data;
  }

  rejectTradeRequest(rejectId: number, rejectReason: string): Observable<any> {
    const data =  this.http.put<TradeRequest[]>('/users/trade/reject/' + rejectId, {
      rejectReason: rejectReason
    });
    return data;
  }

}
